import { Bar, BarChart, CartesianGrid, Cell, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Legend } from "recharts";

export const COLORS = ["#1A3323", "#5C7F55", "#3D6F4B", "#9CB8A3", "#2A2E2B", "#B9D3A8", "#7C9A6E"];

const Box = ({ children, h = 240 }) => <div style={{ width: "100%", height: h }}>{children}</div>;
const NoData = () => <div className="flex h-[200px] items-center justify-center text-sm text-muted-foreground">Belum ada data</div>;

export function PieBox({ data }) {
  if (!data?.length) return <NoData />;
  return (
    <Box>
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={2}>
            {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
          </Pie>
          <Tooltip /><Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
}

export function BarBox({ data, dataKey = "value", horizontal, color = COLORS[0], fmt }) {
  if (!data?.length || data.every((d) => !d[dataKey])) return <NoData />;
  return (
    <Box h={horizontal ? Math.max(200, data.length * 32) : 240}>
      <ResponsiveContainer>
        <BarChart data={data} layout={horizontal ? "vertical" : "horizontal"} margin={{ left: horizontal ? 20 : 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e2d6" />
          {horizontal ? <><XAxis type="number" allowDecimals={false} /><YAxis type="category" dataKey="name" width={100} tick={{ fontSize: 12 }} /></> : <><XAxis dataKey="name" tick={{ fontSize: 12 }} /><YAxis allowDecimals={false} /></>}
          <Tooltip formatter={fmt} cursor={{ fill: "#E3EDD9" }} />
          <Bar dataKey={dataKey} fill={color} radius={horizontal ? [0, 6, 6, 0] : [6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}

export function LineBox({ data }) {
  if (!data?.length) return <NoData />;
  return (
    <Box>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e2d6" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} /><YAxis allowDecimals={false} /><Tooltip />
          <Line type="monotone" dataKey="value" stroke="#3D6F4B" strokeWidth={3} dot={{ r: 4, fill: "#1A3323" }} />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}
